import { z } from "zod";
import { DocumentationItemConfigurationV1 } from "./documentation-v1";
import { PageBlockV1 } from "./documentation-block-v1";
import { nullishToOptional } from "../../../helpers";

export const DocumentationPageDataV1 = z.object({
  blocks: z.array(PageBlockV1),
  configuration: nullishToOptional(DocumentationItemConfigurationV1),
});
